import Vue from 'vue';
import VueLocalStorage from 'vue-localstorage';

Vue.use(VueLocalStorage);

let default_adults = 2,
  default_travelers = [];

for (let index = 1; index <= default_adults; index++) {
  default_travelers.push({
    id: index,
    travelerType: 'ADULT',
    fareOptions: ['STANDARD'],
  });
}

let state = {
  loading: false,
  toggle_loading: false,
  adults: default_adults, // 1 adulto di default
  children: [],
  travelers: default_travelers,
  max_number_of_connections: 2,
  included_checked_bags_only: 0,
  cabin: '',
  departure_airport: process.env.VUE_APP_MODE == 'development_' ? 'LON' : '',
  departure_airport_label:
    process.env.VUE_APP_MODE == 'development_' ? 'Tutti gli aeroporti di Londra' : 'Partenza da...',
  arrival_airport: process.env.VUE_APP_MODE == 'development_' ? 'NYC' : '',
  arrival_airport_label:
    process.env.VUE_APP_MODE == 'development_' ? 'Tutti gli aeroporti di New York' : 'Arrivo a...',
  departure_date: (
    ('0' + new Date().getDate()).slice(-2) +
    '/' +
    ('0' + (new Date().getMonth() + 1)).slice(-2) +
    '/' +
    new Date().getFullYear()
  )
    .split('/')
    .reverse()
    .join('-'),
  return_date: (
    ('0' + new Date().getDate()).slice(-2) +
    '/' +
    ('0' + (new Date().getMonth() + 1)).slice(-2) +
    '/' +
    new Date().getFullYear()
  )
    .split('/')
    .reverse()
    .join('-'),
  results: [],
  suggestions: [],
  can_search_suggestions: true,
  return_flight: true,
  flight_offer: {},
  flight_offer_has_upsell: false,
  bags: {},
  flexible_bags: {},
  has_flexible_bags_last_selection: false, // serve a tenere traccia dell'ultima (eventuale) selezione di bagagli per mostrare o meno il warning all'utente in caso di cambio tariffa
  sort_by: 'price',
  filter_carriers: [],
  // filtri su viaggio di andata/ritorno (round_trip/return_trip - primo itinerario/secondo itinerario) - possibili valori: 'morning', 'early_afternoon', 'late_afternoon', 'evening'
  filter_round_trip_departure: '',
  filter_round_trip_arrival: '',
  filter_return_trip_departure: '',
  //filter_return_trip_arrival: '' non richiesto per il momento
  filter_included_bags: false,
  filter_extra_bags: false,
  traveler_details: [],
  contact_details: {},
};

// state from browser local storage
let localStorageState = Vue.localStorage.get(process.env.VUE_APP_STORE_KEY);

if (localStorageState) {
  let localState = JSON.parse(localStorageState).liveflight;
  if (localState) {
    let newState = localState;
    if (newState) {
      Object.keys(newState).forEach((e) => {
        if (newState[e] && newState[e] != null) {
          state[e] = newState[e];
        }
      });
    }
    //state.travelers = localState.travelers
  }
  state.loading = false;
  state.toggle_loading = false;
}

let liveflightStore = {
  state: state,
  mutations: {
    loading(state, data) {
      state.loading = data;
    },
    toggle_loading(state) {
      state.loading = !state.loading;
    },
    adults(state, data) {
      state.adults = data;
    },
    children(state, data) {
      state.children = data;
    },
    travelers(state, data) {
      state.travelers = data;
    },
    max_number_of_connections(state, data) {
      state.max_number_of_connections = data;
    },
    included_checked_bags_only(state, data) {
      state.included_checked_bags_only = data;
    },
    cabin(state, data) {
      state.cabin = data;
    },
    departure_airport(state, data) {
      state.departure_airport = data;
    },
    departure_airport_label(state, data) {
      state.departure_airport_label = data;
    },
    arrival_airport(state, data) {
      state.arrival_airport = data;
    },
    arrival_airport_label(state, data) {
      state.arrival_airport_label = data;
    },
    departure_date(state, data) {
      if (!data) return;
      state.departure_date = data;
      let date = new Date(data);
      date.setDate(date.getDate());

      let departure_date = new Date(data),
        return_date = new Date(state.return_date);

      if (departure_date >= return_date) {
        state.return_date =
          date.getFullYear() +
          '-' +
          ('0' + (date.getMonth() + 1)).slice(-2) +
          '-' +
          ('0' + date.getDate()).slice(-2);
      }
    },
    return_date(state, data) {
      state.return_date = data;
    },
    results(state, data) {
      state.results = data;
    },
    dictionaries(state, data) {
      state.results.dictionaries = data;
    },
    suggestions(state, data) {
      state.suggestions = data;
    },
    can_search_suggestions(state, data) {
      state.can_search_suggestions = data;
    },
    return_flight(state, data) {
      state.return_flight = data;
    },
    flight_offer(state, data) {
      state.flight_offer = data;
    },
    flight_offer_has_upsell(state, data) {
      state.flight_offer_has_upsell = data;
    },

    bags(state, data) {
      state.bags = data;
    },
    flexible_bags(state, data) {
      state.flexible_bags = data;
    },
    has_flexible_bags_last_selection(state, data) {
      state.has_flexible_bags_last_selection = data;
    },
    sort_by(state, data) {
      state.sort_by = data;
    },
    filter_carriers(state, data) {
      state.filter_carriers = data;
    },
    filter_round_trip_departure(state, data) {
      state.filter_round_trip_departure = data;
    },
    filter_round_trip_arrival(state, data) {
      state.filter_round_trip_arrival = data;
    },
    filter_return_trip_departure(state, data) {
      state.filter_return_trip_departure = data;
    },
    filter_included_bags(state, data) {
      state.filter_included_bags = data;
    },
    filter_extra_bags(state, data) {
      state.filter_extra_bags = data;
    },
    traveler_details(state, data) {
      state.traveler_details = data;
    },
    contact_details(state, data) {
      state.contact_details = data;
    },
  },
  getters: {
    /*
    getTestValue(state)
    {
        return state.testValue
    },
    */
  },
  actions: {
    /*
        // mutations -> operazioni SINCRONE (triggerate da .commit())
        // actions -> operazioni ASINCRONE che lanciano mutations (triggerate da .dispatch())
        incrementAsync ({ commit }) {
            setTimeout(() => {
            commit('increment')
            }, 1000)
        }
    */
  },
};

export { liveflightStore };
